var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.75278V19.7528M12 6.75278C10.8321 5.97686 9.24649 5.5 7.5 5.5C5.75351 5.5 4.16789 5.97686 3 6.75278V19.7528C4.16789 18.9769 5.75351 18.5 7.5 18.5C9.24649 18.5 10.8321 18.9769 12 19.7528M12 6.75278C13.1679 5.97686 14.7535 5.5 16.5 5.5C18.2465 5.5 19.8321 5.97686 21 6.75278V19.7528C19.8321 18.9769 18.2465 18.5 16.5 18.5C14.7535 18.5 13.1679 18.9769 12 19.7528",
    stroke: "#818586",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/Create.15e5ec5ffe6a4177b36ddd92c471a5a0.svg";
export { ForwardRef as ReactComponent };